export class GapFiller {
    private static isEmptyObject(obj: object) {
        return Object.keys(obj).length === 0 && obj.constructor === Object;
    }

    private static isJustDateObject(obj: object) {
        return (
            Object.keys(obj).length === 1 && ("date_at" in obj || "datetime_at" in obj) && obj.constructor === Object
        );
    }

    private static keyHasTimeComponent(key: string) {
        // Check if key already contains time (e.g., "2026-01-26 00:00:00")
        return /\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}/.test(key);
    }

    private static ensureDatetimeFormat(key: string) {
        return GapFiller.keyHasTimeComponent(key) ? key : key + " 00:00:00";
    }

    public static moveDateKeysIntoObjects<TData extends object>(data: TData): TData {
        return Object.fromEntries(
            Object.entries(data).map(([key, value]) => {
                if (GapFiller.isEmptyObject(value)) {
                    return [key, { datetime_at: GapFiller.ensureDatetimeFormat(key) }];
                }

                return [key, value];
            })
        ) as TData;
    }

    public static mapEntitiesToObjects<TData extends object>(data: TData): TData {
        const entities = new Set(Object.values(data).flatMap((dateEntry) => Object.keys(dateEntry)));

        return Object.fromEntries(
            Object.entries(data).map(([key, value]) => {
                const newValue = { ...value } as { [key: string]: unknown };

                entities.forEach((entity) => {
                    if (!(entity in newValue)) {
                        newValue[entity] = {
                            datetime_at: GapFiller.ensureDatetimeFormat(key),
                        };
                    }
                });

                return [key, newValue];
            })
        ) as TData;
    }

    public static fillPerformanceGraphGaps<TData extends object, TPath extends keyof TData>(
        data: TData[],
        metrics: TPath[]
    ): TData[] {
        return data.map((entry) => {
            if (GapFiller.isJustDateObject(entry)) {
                return {
                    ...entry,
                    ...metrics.reduce((acc, metric) => ({ ...acc, [metric]: 0 }), {} as { [key in TPath]: number }),
                } as TData;
            }

            return entry;
        });
    }
}
